import {Slider, Button} from 'antd'
import {LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined} from '@ant-design/icons'
import moment from 'moment'
import React, {useState, useEffect} from 'react'

const ChartPeriodControls = ({setDaysToView, period, setPeriod}) => {
  const [days, setDays] = useState(1)

  useEffect(() => {
    const end = moment().startOf('day').add(1, 'days') // tomorrow
    const start = end.clone().subtract(days, 'days')

    setPeriod({start: start.toISOString(), end: end.toISOString()})
    setDaysToView(days)
  }, [days])

  const shiftTimeline = direction => {
    if (!period?.start || !period?.end) return

    const start = moment(period.start).add(direction, 'days')
    const end = moment(period.end).add(direction, 'days')

    const now = moment().startOf('day')
    if (end.isAfter(now.clone().add(1, 'days'))) return

    setPeriod({
      start: start.toISOString(),
      end: end.toISOString()
    })
  }

  const shiftTimelineByRange = direction => {
    if (!period?.start || !period?.end) return

    const shift = direction * days
    const newStart = moment(period.start).add(shift, 'days')
    const newEnd = moment(period.end).add(shift, 'days')

    const tomorrow = moment().startOf('day').add(1, 'days')

    if (newEnd.isAfter(tomorrow)) {
      // Cap end at "tomorrow" and recalculate start
      const end = tomorrow
      const start = end.clone().subtract(days, 'days')
      setPeriod({
        start: start.toISOString(),
        end: end.toISOString()
      })
    } else {
      setPeriod({
        start: newStart.toISOString(),
        end: newEnd.toISOString()
      })
    }
  }

  return (
    <div id="target-controls">
      <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <Button icon={<DoubleLeftOutlined />} onClick={() => shiftTimelineByRange(-1)} />
        <Button icon={<LeftOutlined />} onClick={() => shiftTimeline(-1)} />

        <div style={{display: 'flex', alignItems: 'center', gap: '10px', width: 250}}>
          <Slider
            min={1}
            max={30}
            value={days}
            onChange={value => setDays(value)}
            tooltip={{open: false}}
            style={{flex: 1}}
          />
          <div>
            {days} day{days > 1 ? 's' : ''}
          </div>
        </div>

        <Button icon={<RightOutlined />} onClick={() => shiftTimeline(1)} />
        <Button icon={<DoubleRightOutlined />} onClick={() => shiftTimelineByRange(1)} />
      </div>
    </div>
  )
}

export default ChartPeriodControls
